import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'

interface SearchResultsPaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const MAX_VISIBLE_PAGES = 5

const getPageNumbers = (currentPage: number, totalPages: number): number[] => {
  if (totalPages <= MAX_VISIBLE_PAGES) {
    return Array.from({ length: totalPages }, (_, i) => i + 1)
  }

  if (currentPage <= 3) {
    return [1, 2, 3, 4, 5]
  }

  if (currentPage + 2 >= totalPages) {
    return [
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ]
  }

  return [
    currentPage - 2,
    currentPage - 1,
    currentPage,
    currentPage + 1,
    currentPage + 2,
  ]
}

export const SearchResultsPagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: SearchResultsPaginationProps) => {
  if (totalPages <= 1) return null

  const goPrev = () => onPageChange(Math.max(1, currentPage - 1))
  const goNext = () => onPageChange(Math.min(totalPages, currentPage + 1))

  return (
    <Pagination className="shrink-0 sticky bottom-0 bg-baseColor py-2 max-md:-mx-2 md:static md:py-0">
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious onClick={goPrev} />
        </PaginationItem>

        <li className="flex h-7 items-center px-2 text-xs font-medium text-neutralColor md:hidden">
          {currentPage} / {totalPages}
        </li>

        {getPageNumbers(currentPage, totalPages).map((page) => (
          <PaginationItem key={page} className="hidden md:block">
            <PaginationLink
              isActive={page === currentPage}
              onClick={() => onPageChange(page)}
            >
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem>
          <PaginationNext onClick={goNext} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
